import { render, staticRenderFns } from "./domainNamerRegiser.vue?vue&type=template&id=2726a0af&"
import script from "./domainNamerRegiser.vue?vue&type=script&lang=js&"
export * from "./domainNamerRegiser.vue?vue&type=script&lang=js&"
import style0 from "./domainNamerRegiser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports